// @ts-nocheck
/* eslint-disable */
import { AuthenticationApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import store from '../src/store/index';
import { findGetParameter } from '@/plugins/Utils';

window.appcontainer = {};
window.appcontainer.isiOSAppcontainer = false;
window.appcontainer.isiOSEmployeeApp = false;

window.appcontainer.startLoadingSpinner = startLoadingSpinner;
window.appcontainer.getVersion = getVersion;

window.appcontainer.openSignaturePad = openSignaturePad;
window.appcontainer.didSignSignaturePad = didSignSignaturePad;
window.appcontainer.didCancelSignaturePad = didCancelSignaturePad;

window.appcontainer.saveLoginCredentials = saveLoginCredentials;
window.appcontainer.getLoginCredentials = getLoginCredentials;
window.appcontainer.receiveLoginCredentials = receiveLoginCredentials;

window.appcontainer.startScan = startScan;
window.appcontainer.scanResult = scanResult;

window.appcontainer.takePicture = takePicture;
window.appcontainer.takePictureResult = takePictureResult;
window.appcontainer.takeVideoResult = takeVideoResult;
window.appcontainer.takeOrUploadPicture = takeOrUploadPicture;
window.appcontainer.takeMultiplePictures = takeMultiplePictures;
window.appcontainer.takeOrUploadMedia = takeOrUploadMedia;
window.appcontainer.triggerYesNoPrompt = triggerYesNoPrompt;

window.appcontainer.startMicrophone = startMicrophone;
window.appcontainer.stopMicrophone = stopMicrophone;
window.appcontainer.microphoneResult = microphoneResult;

window.appcontainer.loginMitarbeiterApp = loginMitarbeiterApp;
window.appcontainer.scanQRCode = scanQRCode;

const isMessageHandlerSet = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.startDocumentScanHandler;
const handler = isMessageHandlerSet ? window.webkit.messageHandlers.startDocumentScanHandler : undefined;
const androidHandler = window.appInterface;
const env = process.env.NODE_ENV;

function getVersion() {
	return findGetParameter('appVersion');
}

// Mitarbeiter - App
function loginMitarbeiterApp(imdnet, qrkey, isPassword = false) {
	const loginObject = isPassword ? { imdnet: imdnet, password: qrkey } : { imdnet: imdnet, qrkey: qrkey };
	return AuthenticationApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
		.appsEmployeeLoginPost(loginObject)
		.then(result => {
			if (result.data.id) {
				store.commit('setAppsEmployeeDamageCase', result.data);
				store.commit('setAppsEmployeeLoginStatus', true);
				store.commit('setAppsEmployeeLoginStatusCode', null);
			} else {
				store.commit('setAppsEmployeeLoginStatusCode', result.data.error_id);
			}
		})
		.catch(error => {
			store.commit('setAppsEmployeeLoginStatusCode', error.response.status);
			if (error.response?.status !== 404) console.log(error);
		});
}

// Misc

function saveLoginCredentials(email, password) {
	triggerAction('saveLoginCredentials', { email: email, password: password });
}

// SignaturePad
function openSignaturePad() {
	triggerAction('openSignaturePad');
}

function didSignSignaturePad(sign) {
	sign = 'data:image/jpeg;base64,' + sign;
	triggerEvent('didSignSignaturePad', sign);
}

function didCancelSignaturePad() {
	triggerEvent('didCancelSignaturePad');
}

// Credentials
function getLoginCredentials() {
	triggerAction('requestLoginCredentials');
	return new Promise((resolve, reject) => {
		const timeoutId = setTimeout(() => {
			reject('Timeout');
		}, 1000);
		const listener = event => {
			window.removeEventListener('requestLoginCredentials', listener);
			clearTimeout(timeoutId);
			resolve(event.detail);
		};

		window.addEventListener('requestLoginCredentials', listener);
	});
}

function receiveLoginCredentials(data) {
	triggerEvent('requestLoginCredentials', data);
}

function startLoadingSpinner() {
	triggerEvent('startLoadingSpinner');
}

// Camera - OCR
function startScan() {
	triggerAction('scanPicture');
}

function scanResult(data) {
	data.base64Image = 'data:image/jpeg;base64,' + data.base64Image;
	triggerEvent('scanResult', data);
}

// Camera - Default
function takePicture() {
	triggerAction('takePicture');
}

function takePictureResult(data) {
	triggerEvent('snapshot', data);
}

function takeVideoResult(data) {
	triggerEvent('takeVideoResult', 'data:video/mp4;base64,' + data);
}


function scanQRCode() {
	triggerAction('scanQRCode');
}

function takeOrUploadPicture() {
	triggerAction('takeOrUploadPicture');
}

function takeMultiplePictures() {
	triggerAction('takeMultiplePictures');
}

function takeOrUploadMedia() {
	triggerAction('takeOrUploadMedia');
}

function triggerYesNoPrompt(){
	triggerAction('triggerYesNoPrompt')
}

// Microphone

function startMicrophone() {
	triggerAction('microphone_start');
}

function stopMicrophone() {
	triggerAction('microphone_stop');
}

/*
struct AudioResult: Codable {
    var base64Audio: String = ""
}
 */
function microphoneResult(data) {
	triggerEvent('microphoneResult', 'data:audio/mpeg;base64,' + data.base64Audio);
}

// Helpers

function triggerAction(action, data = {}) {
	const dataPackage = {
		...data,
		command: action,
	};

	if (handler) {
		handler.postMessage(dataPackage);
	} else if (androidHandler) {
		androidHandler.postMessage(JSON.stringify(dataPackage));
	}
}

function triggerEvent(name, data) {
	window.dispatchEvent(new CustomEvent(name, { detail: data }));
}
